"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames4 = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../../ThemeProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var routePropType = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  path: _propTypes["default"].string,
  label: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  template: _propTypes["default"].func
}));

var Nav =
/*#__PURE__*/
function (_Component) {
  _inherits(Nav, _Component);

  function Nav() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Nav);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Nav)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "isSubPath", function (parentPath, path) {
      return path.startsWith("".concat(parentPath, "/"));
    });

    _defineProperty(_assertThisInitialized(_this), "renderLinks", function (routes) {
      var _this$props = _this.props,
          active = _this$props.theme.active,
          activePath = _this$props.activePath,
          matchSubPath = _this$props.matchSubPath,
          template = _this$props.template;
      return _react["default"].createElement("ul", null, routes.map(function (route) {
        return _react["default"].createElement("li", {
          className: (0, _classnames4["default"])(_defineProperty({}, active, activePath === route.path || matchSubPath && _this.isSubPath(route.path, activePath))),
          key: route.path
        }, route.template ? route.template(route) : template(route));
      }));
    });

    return _this;
  }

  _createClass(Nav, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          theme = _this$props2.theme,
          rightSide = _this$props2.rightSide,
          routes = _this$props2.routes,
          rightRoutes = _this$props2.rightRoutes,
          fluid = _this$props2.fluid,
          underhang = _this$props2.underhang,
          logo = _this$props2.logo;
      return _react["default"].createElement("div", {
        className: (0, _classnames4["default"])(theme.navWrap, _defineProperty({}, theme.underhang, underhang))
      }, _react["default"].createElement("div", {
        className: (0, _classnames4["default"])(theme.nav, _defineProperty({}, theme.fluid, fluid))
      }, _react["default"].createElement("div", {
        className: theme.left
      }, _react["default"].createElement("div", {
        className: theme.logo
      }, logo), routes.length ? this.renderLinks(routes) : null), _react["default"].createElement("div", {
        className: theme.right
      }, rightRoutes.length ? this.renderLinks(rightRoutes) : null, rightSide ? _react["default"].createElement("div", {
        className: theme.rightSide
      }, rightSide) : null)));
    }
  }]);

  return Nav;
}(_react.Component);

_defineProperty(Nav, "propTypes", {
  routes: routePropType,
  rightRoutes: routePropType,
  activePath: _propTypes["default"].string,
  template: _propTypes["default"].func,
  logo: _propTypes["default"].node,
  matchSubPath: _propTypes["default"].bool,
  rightSide: _propTypes["default"].node,
  theme: _propTypes["default"].shape({
    active: _propTypes["default"].string,
    nav: _propTypes["default"].string,
    logo: _propTypes["default"].string
  }),
  fluid: _propTypes["default"].bool,
  underhang: _propTypes["default"].bool
});

_defineProperty(Nav, "defaultProps", {
  matchSubPath: true,
  template: function template(route) {
    return _react["default"].createElement("a", {
      href: route.path
    }, route.label);
  },
  routes: [],
  rightRoutes: [],
  fluid: false,
  underhang: false,
  activePath: '',
  logo: null,
  rightSide: null,
  theme: {}
});

var _default = (0, _ThemeProvider.applyTheme)('InternalNav', Nav);

exports["default"] = _default;